import { API_PROD_URL } from "src/utils/axios";

export const createFoldername = async (
  finalFolderPath: string,
  callback: (value: { loading: boolean; success: boolean; errorType?: string }) => void,
) => {
  try {
    // Start loading
    callback({ loading: true, success: false });

    const response = await fetch(`${API_PROD_URL}/create_folder`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        folder_path: finalFolderPath,
      }),
    });

    // Parse the response (important if API sends error details)
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      callback({
        loading: false,
        success: false,
        errorType: data?.error || "create", // use API error if available
      });
      return;
    }

    // ✅ Success
    callback({ loading: false, success: true });
  } catch (err) {
    console.error("Error creating folder:", err);
    callback({ loading: false, success: false, errorType: "create" });
  }
};

export const fileUpload = async (
  folderName: string,
  selectedFiles: File[],
  callback: (value: { loading: boolean; success: boolean; errorType?: string }) => void,
) => {
  try {
    if (!selectedFiles || selectedFiles.length === 0) {
      callback({ loading: false, success: false, errorType: "no_files" });
      return;
    }

    callback({ loading: true, success: false });

    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append("files", file);
    });

    const uploadResponse = await fetch(`${API_PROD_URL}/upload_files/${folderName}`, {
      method: "POST",
      body: formData,
    });

    if (!uploadResponse.ok) {
      callback({ loading: false, success: false, errorType: "upload_failed" });
      return;
    }

    callback({ loading: false, success: true });
  } catch (err) {
    console.error("Error uploading files:", err);
    callback({ loading: false, success: false, errorType: "network" });
  }
};


export const fetchFiles = async (
  folderName: string,
  callback: (value: { loading: boolean; success: boolean; data?: [] }) => void,
) => {
  try {
    // Step 1: Create folder
    const response = await fetch(`${API_PROD_URL}/list_files/${folderName}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      callback({ loading: false, success: false });
      return;
    }

    const fileData = await response.json();

    // Both steps succeeded
    callback({ loading: false, success: true, data: fileData.files });
  } catch (err) {
    console.error("Error creating folder or uploading files:", err);
    callback({ loading: false, success: false });
  }
};
